// extracted by mini-css-extract-plugin
export var section = "_2r-1";
export var topNav = "_2r-0";